import { FC } from "react";

interface BuildingCategoryIconSVGProps {
    className?: string;
    selected?: boolean;
}

const BuildingCategoryIconSVG: FC<BuildingCategoryIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="63"
            height="63"
            viewBox="0 0 63 63"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {props.selected ? (
                <path
                    d="M39.3747 31.4995L17.3956 53.4787C16.3513 54.5229 14.935 55.1096 13.4581 55.1096C11.9813 55.1096 10.5649 54.5229 9.52061 53.4787C8.47632 52.4344 7.88965 51.018 7.88965 49.5412C7.88965 48.0643 8.47632 46.6479 9.52061 45.6037L31.4997 23.6245M47.2497 39.3745L57.7497 28.8745M56.4372 30.187L51.413 25.1628C50.4284 24.1784 49.875 22.8433 49.8747 21.451V18.3745L43.9422 12.442C41.0142 9.51564 37.0516 7.85972 32.912 7.83253L23.6247 7.76953L26.0397 9.92203C27.7551 11.4429 29.1286 13.3101 30.0697 15.4005C31.0108 17.4909 31.4982 19.757 31.4997 22.0495V26.2495L36.7497 31.4995H39.8262C41.2185 31.4998 42.5537 32.0531 43.538 33.0378L48.5622 38.062"
                    stroke="white"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            ) : (
                <>
                    <path
                        d="M39.3747 31.4995L17.3956 53.4787C16.3513 54.5229 14.935 55.1096 13.4581 55.1096C11.9813 55.1096 10.5649 54.5229 9.52061 53.4787C8.47632 52.4344 7.88965 51.018 7.88965 49.5412C7.88965 48.0643 8.47632 46.6479 9.52061 45.6037L31.4997 23.6245M47.2497 39.3745L57.7497 28.8745M56.4372 30.187L51.413 25.1628C50.4284 24.1784 49.875 22.8433 49.8747 21.451V18.3745L43.9422 12.442C41.0142 9.51564 37.0516 7.85972 32.912 7.83253L23.6247 7.76953L26.0397 9.92203C27.7551 11.4429 29.1286 13.3101 30.0697 15.4005C31.0108 17.4909 31.4982 19.757 31.4997 22.0495V26.2495L36.7497 31.4995H39.8262C41.2185 31.4998 42.5537 32.0531 43.538 33.0378L48.5622 38.062"
                        stroke="url(#paint0_linear_196_10143)"
                        strokeWidth="4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_196_10143"
                            x1="7.5"
                            y1="7.99954"
                            x2="49.5"
                            y2="49.9995"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="white" />
                            <stop offset="1" stopColor="#4A4A4F" />
                        </linearGradient>
                    </defs>
                </>
            )}
        </svg>
    );
};

export default BuildingCategoryIconSVG;
